// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar {
  position: fixed;
  padding: 32px;
  height: 100vh;
  background-color: #2C274B;
  width: 281px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  overflow-y: auto;
  box-sizing: border-box;
}

.sidebarItem {
  cursor: pointer;
  transition: 0.1s;
  width: 100%;
  height: 56px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding-left: 18px;
  gap: 16px;
  color: white;
  align-items: center;
}
.sidebarItem--active {
  background: #1A193C;
}
.sidebarItem:hover {
  background: #1A193C;
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.scss","webpack://./src/assets/styles/colorsVariables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,aAAA;EACA,aAAA;EACA,yBCLa;EDMb,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;AADF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;AAAF;AACE;EACE,mBAAA;AACJ;AACA;EACE,mBAAA;AACF","sourcesContent":["@import '~@assets/styles/colorsVariables.scss';\r\n\r\n.Sidebar {\r\n  position: fixed;\r\n  padding: 32px;\r\n  height: 100vh;\r\n  background-color: $sidebarColor;\r\n  width: 281px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 16px;\r\n  overflow-y: auto;\r\n  box-sizing: border-box;\r\n}\r\n.sidebarItem {\r\n  cursor: pointer;\r\n  transition: 0.1s;\r\n  width: 100%;\r\n  height: 56px;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  padding-left: 18px;\r\n  gap: 16px;\r\n  color: white;\r\n  align-items: center;\r\n  &--active {\r\n    background: #1A193C;\r\n}\r\n&:hover {\r\n  background: #1A193C;\r\n}\r\n}","$backGroundColor: #eff0f4;\r\n$sidebarColor: #2C274B;\r\n\r\n$mainColor: #c6f432;\r\n\r\n$toggleAndSuccessState: #4ce417;\r\n$error: #e50000;\r\n\r\n$text: #000000;\r\n$secondaryText: #898989;\r\n\r\n$hoverButton: #aee10c;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Sidebar": `Sidebar`,
	"sidebarItem": `sidebarItem`,
	"sidebarItem--active": `sidebarItem--active`
};
export default ___CSS_LOADER_EXPORT___;
